import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { CalendarX2, Inbox } from "lucide-react";

const STATUS_CLASSES = {
  ny: "border-foreground/30 bg-foreground/[0.06] text-foreground",
  godkjend: "border-emerald-700/30 bg-emerald-700/10 text-emerald-800",
  avvist: "border-rose-700/30 bg-rose-700/10 text-rose-800",
  ledig: "border-emerald-700/30 bg-emerald-700/10 text-emerald-800",
  oppteke: "border-rose-700/30 bg-rose-700/10 text-rose-800",
  privat: "border-border bg-secondary text-muted-foreground",
  fast: "border-amber-600/30 bg-amber-500/10 text-amber-800",
  heile: "border-foreground bg-foreground text-background",
  public: "border-foreground/30 bg-foreground/[0.06] text-foreground",
  open: "border-emerald-700/30 bg-emerald-700/10 text-emerald-800",
  closed: "border-rose-700/30 bg-rose-700/10 text-rose-800",
};

const STATUS_TEXT = {
  ny: "Ny",
  godkjend: "Godkjend",
  avvist: "Avvist",
  ledig: "Ledig",
  oppteke: "Oppteke",
  privat: "Privat arrangement",
  fast: "Fast aktivitet",
  heile: "Heile huset",
  public: "Ope arrangement",
  open: "Open for booking",
  closed: "Mellombels stengt",
};

export const StatusBadge = ({ status, label, className, ...props }) => (
  <Badge variant="outline" className={cn(STATUS_CLASSES[status] || "", className)} {...props}>
    {label || STATUS_TEXT[status] || status}
  </Badge>
);

export const Dot = ({ kind, className }) => {
  const map = {
    public: "bg-foreground",
    privat: "bg-muted-foreground",
    fast: "bg-sol",
    heile: "bg-foreground",
    oppteke: "bg-rose-600",
    ledig: "bg-emerald-600",
  };
  return <span className={cn("inline-block h-2 w-2 shrink-0 rounded-full", map[kind] || "bg-muted-foreground", className)} />;
};

export const EmptyState = ({ icon: Icon = Inbox, title, text, action, className, ...props }) => (
  <div className={cn("rounded-[20px] border border-dashed border-input px-6 py-14 text-center", className)} {...props}>
    <div className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-secondary text-muted-foreground">
      <Icon className="h-5 w-5" />
    </div>
    <h3 className="t-h3">{title}</h3>
    {text && <p className="mx-auto mt-2 max-w-md text-[15px] leading-relaxed text-muted-foreground">{text}</p>}
    {action && <div className="mt-6 flex justify-center gap-2">{action}</div>}
  </div>
);

export const NoEvents = EmptyState;
export { CalendarX2 };
